import styled, { css } from 'styled-components/macro';
import { colorBlackTransparent200, colorBlackTransparent50, colorCoreBlack300, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { fontSizeM, fontWeightMedium, lineHeightS, RegularTextLevel4, } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const RadioButtonContainerStyled = styled.div ``;
export const RadioButtonStyled = styled.input `
  visibility: hidden;
  position: absolute;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0;
`;
export const Label = styled.label `
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: 30px' : 'margin-left: 30px')};
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  display: block;
  position: relative;
  ${({ isDisabled }) => !isDisabled && 'cursor: pointer;'}
  color: ${({ isDisabled }) => (isDisabled ? colorCoreBlack300 : colorCoreBlack900Base)};

  ${({ isCornerTextRightAlign }) => isCornerTextRightAlign &&
    css `
      width: 100%;
      display: flex;
      justify-content: space-between;
    `}

  &::before {
    ${({ isRightToLeft }) => (isRightToLeft ? 'right: -30px;' : 'left: -30px;')}
    top: ${({ isLabel }) => (isLabel ? ' 1px' : '-10px')};
    border-color: ${({ isChecked, isDisabled }) => {
    if (isDisabled) {
        return isChecked ? colorCoreBlack300 : colorBlackTransparent50;
    }
    return isChecked ? colorCoreBlack900Base : colorBlackTransparent200;
}};

    content: '';
    box-sizing: border-box;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
  }

  &::after {
    ${({ isRightToLeft }) => (isRightToLeft ? 'right: -25px;' : 'left: -25px;')}
    top: ${({ isLabel }) => (isLabel ? '6px' : '-5px')};
    display: ${({ isChecked }) => (isChecked ? 'block' : 'none')};

    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ isDisabled }) => isDisabled ? colorCoreBlack300 : colorCoreBlack900Base};
    -webkit-tap-highlight-color: transparent;
  }
`;
export const RadioButtonsGroupContainer = styled.div `
  ${fontWeightMedium};
  ${lineHeightS};
  ${fontSizeM};
  color: ${colorCoreBlack900Base};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  display: flex;
  flex-direction: column;
`;
export const CornerTextStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  display: flex;
  align-items: center;
`;
export const InnerNodeStyled = styled.i `
  display: flex;
  flex-flow: row wrap;
  gap: 6px;
  margin-left: auto;
  flex: 1 0 auto;
`;
export const RadioButtonMainStyled = styled.span `
  display: flex;
  align-items: ${({ $isMobileView }) => ($isMobileView ? 'flex-start' : 'center')};
  ${({ $isMobileView }) => $isMobileView && 'flex-flow: column wrap'};
  & > i {
    margin-left: ${({ $isMobileView }) => ($isMobileView ? '30px' : 'auto')};
  }
`;
export const AdditionalTextStyled = styled(RegularTextLevel4) `
  ${({ isRightToLeft }) => (isRightToLeft ? 'padding-right: 30px;' : 'padding-left: 30px;')}
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  margin-top: 4px;
`;
export const LabelWrapperStyled = styled.span `
  ${({ isRightToLeft }) => `
  flex-direction: ${isRightToLeft ? 'row-reverse' : 'row'};
  justify-content: ${isRightToLeft ? 'flex-end' : 'space-between'};
`}

  width: 100%;
  display: flex;
  align-items: center;
`;
